import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen pt-28 pb-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-[#a1a1aa] text-sm mb-8">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight className="w-3.5 h-3.5" />
          <span className="text-white">Refund Policy</span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Refund <span className="text-[#dc2626]">Policy</span>
          </h1>
          <p className="text-[#71717a] text-sm mb-12">Last updated: 01 January 2026</p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Introduction</h2>
              <p className="text-[#a1a1aa] leading-relaxed">
                At Cube Multimedia, we are committed to providing exceptional services and digital products. Please read this Refund & Return Policy carefully, as it outlines our guidelines regarding refunds and returns.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Refunds</h2>
              <p className="text-[#a1a1aa] leading-relaxed mb-4">
                Cube Multimedia does not offer refunds for any services or digital products. Once a purchase is made, it is considered final, and no refunds will be provided under any circumstances.
              </p>
              <p className="text-[#a1a1aa] leading-relaxed">
                To avoid any misunderstandings, please ensure that you understand this policy before making any payment.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Returns</h2>
              <p className="text-[#a1a1aa] leading-relaxed mb-4">
                Given the digital nature of our services and products, there are no physical items to return. Therefore, we do not accept returns for any services or digital products, including but not limited to:
              </p>
              <ul className="list-disc list-inside text-[#a1a1aa] space-y-2">
                <li>Digital marketing services</li>
                <li>Content creation services</li>
                <li>Graphic design services</li>
                <li>Video editing services</li>
                <li>Website design and development services</li>
                <li>Any other digital products or services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Applicability of Policy</h2>
              <p className="text-[#a1a1aa] leading-relaxed mb-4">
                This refund policy applies to all transactions, regardless of the payment method used. Payments made via bank transfer, UPI, cash, or any other offline or online means are covered under this policy.
              </p>
              <p className="text-[#a1a1aa] leading-relaxed">
                Furthermore, transactions made outside of Cube Multimedia's official website (<strong className="text-white">cubemultimedia.in</strong>) are still bound by this refund policy, as cubemultimedia.in is the property of Cube Multimedia.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Contact Us</h2>
              <p className="text-[#a1a1aa] leading-relaxed">
                If you have any questions or concerns regarding this Refund & Return Policy, please contact us at{" "}
                <a href="mailto:contact@cubemultimedia.in" className="text-[#dc2626] hover:underline">
                  contact@cubemultimedia.in
                </a>
                . Our team is here to assist you and provide any necessary information or support.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
